import { createAction } from '@reduxjs/toolkit'

export const updateSelection = createAction('filter/updateSelection')
